import { render, staticRenderFns } from "./PhysioDrugManage.vue?vue&type=template&id=b2f3e86c&scoped=true"
import script from "./PhysioDrugManage.vue?vue&type=script&lang=js"
export * from "./PhysioDrugManage.vue?vue&type=script&lang=js"
import style0 from "./PhysioDrugManage.vue?vue&type=style&index=0&id=b2f3e86c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f3e86c",
  null
  
)

export default component.exports